// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d534d3e0","453":"05f8c4a7","732":"ab81b108"}[chunkId] + ".chunk.js";
};